import React from "react";
import ProViewField from '../../components/common/ProViewField';
import { Allergy, Medication } from "../../constants/ProIcons";
import _ from 'lodash'

const ProClientDetails = ({clientData})=>{ 

    let baseUrl = _.gt(window.location.ancestorOrigins.length, 0)?_.first(window.location.ancestorOrigins) : "https://example.com"
   
    const url = `${baseUrl}/clients/edit.jsp?sid=${localStorage.getItem('sid')}&s_id=${clientData.clientId}&mode=change`

    return <div>
                <div className="p-field p-grid view-form">
                     { (clientData.occupantType === 'CLIENT') && <>
                      <a className="p-col-fixed"  rel="noreferrer" href={url} target="_blank">
                          <span aria-hidden="true" style={{ fontWeight: 'bold', color:'blue', textDecoration:'underline' }}>{clientData.clientName} </span>
                     </a> 
                    <span>({clientData.clientNumber})</span> </> }
                    { clientData.occupantType !== 'CLIENT' && 
                      <a className="p-col-fixed" style={{ fontWeight: 'bold' }}>
                         {clientData.dependentName} 
                          </a>
                     }
                </div>
                { clientData.occupantType === 'CLIENT' && 
                    <div style={{width:'100%', padding:'0px', textAlign: 'left'}} className="p-field p-grid view-form">
                        <div style={{width:'75%', padding:'0px'}} className="p-col-fixed">
                            <ProViewField labelText="Sex" value={clientData.sex} width="150px"></ProViewField>
                            <ProViewField labelText="DOB" value={clientData.dateOfBirth}  width="150px"></ProViewField>
                            <ProViewField labelText="Age" value={clientData.age}  width="150px"></ProViewField>
                            <ProViewField labelText="Primary Staff" value={clientData.primaryStaffName}  width="150px"></ProViewField>
                            <ProViewField labelText="Primary Program" value={clientData.primaryProgramName}  width="150px"></ProViewField>
                            <ProViewField labelText="Age Range Category" value={clientData.ageRangeCategory}  width="150px"></ProViewField>
                        </div>
                        <div className="p-col">
                        { _.isEmpty(clientData.photo) && <>
                                                            {/* <i className="fad fa-user-alt" style={{ fontSize: 84 }}></i> */}
                                                        <div style={{ fontWeight:'bold', fontSize:14, margin:'10px'}}>No Photo Available</div></> }
                        {!_.isEmpty(clientData.photo) && <img src={`data:image/jpeg;base64,${clientData.photo}`} 
                                                                style={{height:"100px", width:"100px", objectFit:"cover" ,padding:"5px"}} />}

                        <div style={{clear:'both', height:'3px'}}></div>
                        { clientData.occupantType === 'CLIENT' && clientData.hasClientMedications && 
                            <i className ="fas" aria-hidden="true" style={_.isEmpty(clientData.photo)?{ color: 'red', fontSize: 14, marginLeft:'15px' }:{ color: 'red', fontSize: 14, marginLeft:'25px' }}>
                                <Medication/>
                            </i>
                        }
                        { clientData.occupantType === 'CLIENT' && clientData.hasClientAllergy && 
                            <i className ="fas" aria-hidden="true" style={{ color: 'green', fontSize: 14,}}>
                                <Allergy/>
                            </i>
                        }                        
                        </div>
                    </div>
                }
               { clientData.occupantType !== 'CLIENT' && 
                    <div style={{width:'100%'}}>
                        <ProViewField labelText="Dependent of" value={clientData.clientName + ' (#'+clientData.clientNumber+')'}  width="150px"></ProViewField>
                    </div>
                }
                <div style={{width:'100%'}}>
                    <ProViewField labelText="Start Date" value={clientData.startDate}  width="150px"></ProViewField>
                    <ProViewField labelText="End Date"value={clientData.endDate}  width="150px"></ProViewField>
                    <ProViewField labelText="Length of Stay" value={clientData.lengthOfStay}  width="150px"></ProViewField>
                </div>
                { clientData.occupantType === 'CLIENT' && 
                    <div style={{width:'100%'}}>
                        <ProViewField labelText="Anticipated Payer" value={clientData.anticipatedPayer}  width="150px"></ProViewField>                       
                    </div>
                }
        </div>

    }

export default ProClientDetails;

